import MojitoServices from 'mojito/services';

import {merge} from '#core/utils/config-utils.js';
import {resolveBackground} from '#core/utils/color-utils.js';

import {ApplicationConfig} from '#core/config/application-config.js';

import {generatePromotionQuickLinks} from '#core/application/modules/tiles/promotion-quick-links/index.js';
import {generateSkeletonPart} from '#core/application/modules/tiles/skeleton-part/index.js';
import {generateSearchInput} from '#core/application/modules/tiles/search/search-input.js';
import {PRICE_BOOST_ICON_SRC} from '#core/application/modules/tiles/price-boost-label/index.js';
const {LOCATION} = MojitoServices.Promotions.types;

export function homePageFactory(PALETTE) {
    const HOME_PAGE_TOP_SPORTS_SKELETON = generateSkeletonPart(PALETTE.HOME_PAGE_TOP_SPORTS_SKELETON_PART);

    return {
        HomePage: {
            primaryContentLayout: {
                createStackingContext: true,
            },
            searchControllerView: {
                searchView: {
                    searchInput: generateSearchInput(PALETTE.HOME_PAGE_SEARCH_INPUT),
                },
            },
            topContextMenu: {
                baseLink: {
                    icon: {
                        style: {
                            fill: PALETTE.HOME_PAGE_PROMOTION_QUICK_LINKS_ICON_COLOR,
                        },
                    },
                },
                priceBoostLink: {
                    icon: {
                        src: PRICE_BOOST_ICON_SRC,
                        style: {
                            fill: PALETTE.HOME_PAGE_PROMOTION_QUICK_LINKS_ICON_COLOR,
                        },
                    },
                },
                // Mobile Quick Links
                rowLinkMenu: merge(generatePromotionQuickLinks(PALETTE.HOME_PAGE_PROMOTION_QUICK_LINKS), {
                    menuRow: {
                        buttonScrollPane: {
                            contentContainer: {
                                style: {
                                    _mobile_padding: '0 0 0 8px',
                                },
                            },
                        },
                    },
                    extraLinksInFront: ApplicationConfig.config.priceBoostLinkInFront, // todo rework on MOJ-15405
                }),
            },
            topLinkPromotions: {
                _mobile_locationId: LOCATION.TOP_QUICK_LINKS,
                menuRowSkeleton: {
                    container: {
                        style: {
                            ...resolveBackground(PALETTE.HOME_PAGE_TOP_SPORTS_CONTAINER_BG),
                            padding: '12px 4px',
                        },
                    },
                    iconPlaceholder: HOME_PAGE_TOP_SPORTS_SKELETON,
                    linkPlaceholder: HOME_PAGE_TOP_SPORTS_SKELETON,
                },
                menuRow: {
                    style: {
                        container: {
                            ...resolveBackground(PALETTE.HOME_PAGE_TOP_SPORTS_CONTAINER_BG),
                            height: '48px',
                            padding: '4px 0',
                            alignItems: 'center',
                        },
                    },
                    item: {
                        // only unselected because these items cannot be selected
                        unselected: {
                            style: {
                                base: {
                                    padding: 0,
                                    ...PALETTE.HOME_PAGE_TOP_SPORTS_SPORT_TEXT,
                                },
                            },
                        },
                    },
                    itemIcon: {
                        style: {
                            width: '20px',
                            maxWidth: '20px',
                            height: '20px',
                            maxHeight: '20px',
                            fill: PALETTE.HOME_PAGE_TOP_SPORTS_ROW_ICON_COLOR,
                        },
                    },
                    itemInnerContainer: {
                        style: {
                            padding: '0 2px',
                        },
                    },
                },
            },
            topBannerPromotions: {
                locationId: LOCATION.TOP,
                view: {
                    container: {
                        style: {
                            display: 'block',
                        },
                    },
                },
            },
            // minimum requirement to prevent mojito from crashing
            leftPromotions: {
                locationId: LOCATION.LEFT,
            },
        },
    };
}
